export enum PluginMessagesEnum {
  init = 'wefgbuoht48930ht8034h',
  getDomains = 'wfuob83490bfg830',
  confirmPluginAgreement = '5h480thj39-jt39-tjkjfkmk',
  getProfileContacts = 'gbuoweb893438fh8',
  getCandidateStatistic = 'y840th90354g4g4g'
}
